// extracted by mini-css-extract-plugin
export default {"wrapper":"Error_wrapper__jiz27","amprimary":"Error_amprimary__6gXKP"};